<template>
  <div class="meal">
    <toolbar transparent fixed :logo="false">
      <template v-slot:right>
        <toolbar-add-to-schedule-button
          class="mr-1"
          :item-id="id"
          item-type="Meal"
          page-content-type="meal"
        />
        <toolbar-bookmark-button class="mr-1" :page-id="page_id" />
        <toolbar-share-button />
      </template>
    </toolbar>

    <template v-if="isPresent(banner)">
      <div class="bg-white">
        <hero :image="banner" safe-padding />
      </div>
    </template>
    <template v-else>
      <div class="v-toolbar__spacer"></div>
    </template>

    <text-block-header :heading="title">
      <icon-container icon="schedule" :content="time" sub-content="Mins" />
      <icon-container
        v-if="serves"
        icon="restaurant_menu"
        :content="serves"
        sub-content="Serves"
      />
      <icon-container
        v-if="calories"
        icon="local_pizza"
        :content="calories"
        sub-content="Calories"
      />
      <icon-container
        v-if="carbs"
        icon="rice_bowl"
        :content="carbs"
        :sub-content="`Carbs`"
      />
      <icon-container
        v-if="fat"
        icon="water_drop"
        :content="fat"
        sub-content="fat"
      />
      <icon-container
        v-if="protein"
        icon="set_meal"
        :content="protein"
        sub-content="Protein"
      />
      <icon-container
        v-if="fibre"
        icon="grass"
        :content="fibre"
        sub-content="Fibre"
      />
    </text-block-header>

    <tabs :tabs="['Ingredients', 'Directions']">
      <template v-slot:ingredients>
        <text-block
          :space-top-ratio="200"
          :content="ingredients"
          autoconvert-units
        />
      </template>

      <template v-slot:directions>
        <text-block
          :space-top-ratio="200"
          :content="directions"
          autoconvert-units
        />
      </template>
    </tabs>

    <v-made-with-movement v-if="!isDesktop" />
  </div>
</template>

<script>
import { mapState } from "vuex"
import { isPresent } from "@/lib/utils"

import Toolbar from "@/components/Toolbar"
import ToolbarShareButton from "@/components/toolbar/ShareButton"
import ToolbarBookmarkButton from "@/components/toolbar/BookmarkButton"
import ToolbarAddToScheduleButton from "@/components/toolbar/AddToScheduleButton"
import Hero from "@/components/Hero"
import TextBlockHeader from "@/components/TextBlockHeader"
import TextBlock from "@/components/TextBlock"
import Tabs from "@/components/Tabs"
import IconContainer from "@/components/IconContainer"

export default {
  components: {
    Toolbar,
    ToolbarShareButton,
    ToolbarBookmarkButton,
    ToolbarAddToScheduleButton,
    Hero,
    TextBlockHeader,
    TextBlock,
    Tabs,
    IconContainer
  },

  props: {
    id: { type: Number, required: true },
    page_id: { type: Number, required: true },
    title: { type: String, default: "" },
    banner: { type: Object, default: () => ({}) },
    directions: { type: String, default: "" },
    ingredients: { type: String, default: "" },
    calories: { type: Number, default: null },
    fat: { type: String, default: null },
    protein: { type: String, default: null },
    carbs: { type: String, default: null },
    fibre: { type: String, default: null },
    serves: { type: Number, default: null },
    time: { type: Number, default: null }
  },

  head() {
    return {
      title: this.title
    }
  },

  computed: {
    ...mapState("responsive", ["isDesktop"])
  },

  methods: {
    isPresent
  }
}
</script>
